import {
  AssessmentQuestionComment,
  NpsAssessmentQuestionNode,
} from "types/graphql-schema";

import { isEmptyValue } from "@components/wysiwyg/helpers";
import TextareaWysiwyg from "@components/wysiwyg/textarea-wysiwyg";

import AssessmentQuestionRangeOptions from "../assessment-question-range-options";
import SavedAnswerEditorKey from "./saved-answer-editor-key";
import { AssessmentAnswer } from "./types";

const NpsAssessmentQuestionContent = ({
  answer,
  question,
  disabled,
  onChangeAnswer,
}: {
  answer?: { integerAnswer?: number | null; comment?: string | null } | null;
  question: Pick<NpsAssessmentQuestionNode, "comment">;
  disabled?: boolean;
  onChangeAnswer?: (newAnswer: Partial<AssessmentAnswer>) => void;
}) => {
  const comment = answer?.comment ?? "{}";
  return (
    <>
      <AssessmentQuestionRangeOptions
        answer={answer?.integerAnswer}
        disabled={disabled}
        labels={["", "", "", "", "", "", "", "", "", ""]}
        labelDescriptions={["", "", "", "", "", "", "", "", "", ""]}
        startValue={0}
        endValue={10}
        onClickAnswer={(answer) => {
          if (!onChangeAnswer) {
            return;
          }
          onChangeAnswer({
            integerAnswer: answer,
          });
        }}
      />
      {question.comment !== AssessmentQuestionComment.NoComment &&
        answer &&
        (!disabled || !isEmptyValue(answer.comment)) && (
          <div className="mt-4 flex flex-col gap-2">
            <div className="flex items-center justify-between">
              <div className="text-gray-500 text-xs uppercase font-semibold">
                Comment{" "}
                {question.comment === AssessmentQuestionComment.Required
                  ? "*"
                  : ""}
              </div>
            </div>
            <SavedAnswerEditorKey field="comment">
              <TextareaWysiwyg
                editable={!disabled}
                className="bg-white max-w-none"
                value={comment}
                onChangeValue={(comment) => {
                  if (!onChangeAnswer) {
                    return;
                  }
                  onChangeAnswer({
                    comment,
                  });
                }}
              />
            </SavedAnswerEditorKey>
          </div>
        )}
    </>
  );
};

export default NpsAssessmentQuestionContent;
